const DEFAULT_TEXT_COLOR = 'black';
const DEFAULT_PRESSABLE_RIPPLE_COLOR = 'rgba(38, 132, 240, 0.2)';

const constants = {
  DEFAULT_PRESSABLE_RIPPLE_COLOR,
  DEFAULT_TEXT_COLOR
};

export { DEFAULT_TEXT_COLOR, DEFAULT_PRESSABLE_RIPPLE_COLOR };

export default constants;
